import React, { useEffect } from 'react';
import {
    Alert,
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    Tab,
    Tabs,
    Tooltip,
    Typography
} from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import moment from 'moment';
import { useDashboardController } from './context/dashboard-controller';
import { useDashboardState } from './context/dashboard-context';
import PageHeader from '../../../components/page-header';

export function DashboardComponent() {
    const {
        loadData,
        handleTabChange,
        navigateToSubmissionPublications,
        navigateToSubmissionPublicationDetail,
        navigateToOfficialDiaryDetail,
        stringAvatar
    } = useDashboardController();

    const {
        dashboardDetail,
        officialDiaryItems,
        submissionPublicationItems,
        tabIndex
    } = useDashboardState();

    useEffect(() => {
        loadData();
    }, []);

    return (
        <React.Fragment>
            <Grid item xs={12} md={12} lg={12}>
                <PageHeader
                    title="Dashboard"
                    subtitle="Visão geral do Sistema de Diário e Publicações"
                    breadcrumbs={[
                        { label: 'SDP', href: '/sdp' },
                        { label: 'Dashboard' }
                    ]}
                />
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <Grid container spacing={1.5}>
                    <Grid item sm={12}>
                        {dashboardDetail.countNewSubmissionPublication > 0 ? (
                            <Alert
                                severity="warning"
                                action={
                                    <Button
                                        color="inherit"
                                        size="small"
                                        onClick={navigateToSubmissionPublications}
                                    >
                                        Ver Agora
                                    </Button>
                                }
                            >
                                Existem {dashboardDetail.countNewSubmissionPublication} remessa novas disponíveis para publicação.
                            </Alert>
                        ) : (
                            <Alert severity="success">
                                Todas as remessa de publicação estão processadas.
                            </Alert>
                        )}
                    </Grid>

                    <Grid item sm={4}>
                        <Card sx={{ height: '100%' }}>
                            <CardContent>
                                <Grid
                                    container
                                    spacing={3}
                                    sx={{ justifyContent: 'space-between' }}
                                >
                                    <Grid item>
                                        <Typography
                                            color="textSecondary"
                                            gutterBottom
                                            variant="overline"
                                        >
                                            TOTAL DE EDIÇÕES DO DIÁRIO
                                        </Typography>
                                        <Typography color="textPrimary" variant="h2">
                                            {dashboardDetail.countOfficialDaily}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Avatar
                                            sx={{
                                                backgroundColor: 'warning.main',
                                                height: 56,
                                                width: 56
                                            }}
                                        >
                                            <FileCopyIcon />
                                        </Avatar>
                                    </Grid>
                                    <Grid item sx={{ pt: 4 }} xs={12}>
                                        <Typography color="textSecondary" variant="subtitle1">
                                            {dashboardDetail.countOfficialDailyLastMonth} no último mês
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={4}>
                        <Card sx={{ height: '100%' }}>
                            <CardContent>
                                <Grid
                                    container
                                    spacing={3}
                                    sx={{ justifyContent: 'space-between' }}
                                >
                                    <Grid item>
                                        <Typography
                                            color="textSecondary"
                                            gutterBottom
                                            variant="overline"
                                        >
                                            TOTAL DE REMESSA
                                        </Typography>
                                        <Typography color="textPrimary" variant="h2">
                                            {dashboardDetail.countSubmissionPublication}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Avatar
                                            sx={{
                                                backgroundColor: 'info.main',
                                                height: 56,
                                                width: 56
                                            }}
                                        >
                                            <FileUploadIcon />
                                        </Avatar>
                                    </Grid>
                                    <Grid item sx={{ pt: 4 }} xs={12}>
                                        <Typography color="textSecondary" variant="subtitle1">
                                            {dashboardDetail.countSubmissionPublicationLastMonth} no último mês
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={4}>
                        <Grid container spacing={1.5}>
                            <Grid item xs={12}>
                                <Card sx={{ height: '100%' }}>
                                    <CardContent>
                                        <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'space-between' }}
                                        >
                                            <Grid item>
                                                <Typography
                                                    color="textSecondary"
                                                    gutterBottom
                                                    variant="overline"
                                                >
                                                    REMESSA PENDENTES
                                                </Typography>
                                                <Typography color="textPrimary" variant="h6">
                                                    {dashboardDetail.countPendingSubmissionPublication}
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Avatar
                                                    sx={{
                                                        backgroundColor: 'error.main',
                                                        height: 32,
                                                        width: 32
                                                    }}
                                                >
                                                    <FileUploadIcon />
                                                </Avatar>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12}>
                                <Card sx={{ height: '100%' }}>
                                    <CardContent>
                                        <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'space-between' }}
                                        >
                                            <Grid item>
                                                <Typography
                                                    color="textSecondary"
                                                    gutterBottom
                                                    variant="overline"
                                                >
                                                    REMESSA CONCLUIDAS
                                                </Typography>
                                                <Typography color="textPrimary" variant="h6">
                                                    {dashboardDetail.countClosedSubmissionPublication}
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Avatar
                                                    sx={{
                                                        backgroundColor: 'success.main',
                                                        height: 32,
                                                        width: 32
                                                    }}
                                                >
                                                    <FileUploadIcon />
                                                </Avatar>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <Box>
                    <Box>
                        <Tabs value={tabIndex} onChange={handleTabChange}>
                            <Tab label="Últimas Remessas de Publicação" />
                            <Tab label="Últimas Edições do Diário Oficial" />
                        </Tabs>
                    </Box>
                    <Box sx={{ padding: 2 }}>
                        {tabIndex === 0 && (
                            <Box>
                                <List sx={{ width: '100%', bgcolor: 'background.paper' }} disablePadding>
                                    {submissionPublicationItems.items.map((element, index) => {
                                        return (
                                            <React.Fragment key={element.id}>
                                                <ListItem alignItems="flex-start" disablePadding>
                                                    <ListItemButton
                                                        onClick={() => navigateToSubmissionPublicationDetail(element.id)}
                                                    >
                                                        <ListItemAvatar>
                                                            <Tooltip title={element.userSenderName}>
                                                                <Avatar
                                                                    {...stringAvatar(element.userSenderName)}
                                                                    alt={element.userSenderName}
                                                                />
                                                            </Tooltip>
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={element.title}
                                                            secondary={
                                                                <React.Fragment>
                                                                    <Typography
                                                                        sx={{ display: 'inline' }}
                                                                        component="span"
                                                                        variant="body2"
                                                                        color="text.primary"
                                                                    >
                                                                        {element.instruction}
                                                                    </Typography>
                                                                    {' Enviada em: ' + moment(element.sendDate).format("DD/MM/YYYY")}
                                                                </React.Fragment>
                                                            }
                                                        />
                                                    </ListItemButton>
                                                </ListItem>
                                                {index < submissionPublicationItems.items.length - 1 && (
                                                    <Divider variant="inset" component="li" />
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                </List>
                            </Box>
                        )}
                        {tabIndex === 1 && (
                            <Box>
                                <List sx={{ width: '100%', bgcolor: 'background.paper' }} disablePadding>
                                    {officialDiaryItems.items.map((element, index) => {
                                        return (
                                            <React.Fragment key={element.id}>
                                                <ListItem alignItems="flex-start" disablePadding>
                                                    <ListItemButton
                                                        onClick={() => navigateToOfficialDiaryDetail(element.id)}
                                                    >
                                                        <ListItemAvatar>
                                                            <Tooltip title={element.clientName}>
                                                                <Avatar
                                                                    {...stringAvatar(element.clientName)}
                                                                    alt={element.clientName}
                                                                />
                                                            </Tooltip>
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={element.clientName}
                                                            secondary={
                                                                <React.Fragment>
                                                                    <Typography
                                                                        sx={{ display: 'inline' }}
                                                                        component="span"
                                                                        variant="body2"
                                                                        color="text.primary"
                                                                    >
                                                                        {element.description}
                                                                    </Typography>
                                                                    {' ' + moment(element.publicationDate).format("DD/MM/YYYY")}
                                                                </React.Fragment>
                                                            }
                                                        />
                                                    </ListItemButton>
                                                </ListItem>
                                                {index < officialDiaryItems.items.length - 1 && (
                                                    <Divider variant="inset" component="li" />
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                </List>
                            </Box>
                        )}
                    </Box>
                </Box>
            </Grid>
        </React.Fragment>
    );
}
